import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './row.vdt';
import { useGutter } from './useGutter';
import { Value } from './constants';
import { useConfigContext } from '../config';
var typeDefs = {
  gutter: Value,
  justify: ['start', 'end', 'center', 'between', 'around', 'evenly'],
  align: ['top', 'bottom', 'middle', 'stretch', 'baseline']
};
export var Row = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Row, _Component);
  function Row() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.gutter = useGutter();
    _this.config = useConfigContext();
    return _this;
  }
  return Row;
}(Component);
Row.template = template;
Row.typeDefs = typeDefs;